export default __webpack_public_path__ + "static/logo-3-475dc866a80f8a5a8a3740c9588a60b2.jpeg";